import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IndividualsService } from '../individuals.service';

@Component({
    selector: 'app-modal-individuals',
    templateUrl: './modal-individuals.component.html',
    styleUrls: ['./modal-individuals.component.scss'],
    standalone: false
})
export class ModalIndividualsComponent implements OnInit {
  FormGroup: UntypedFormGroup;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private individualsService: IndividualsService,
    public dialogRef: MatDialogRef<ModalIndividualsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    this.setForm();
  }

  setForm() {
    this.FormGroup = this._formBuilder.group({
      authorities: [false, []],
      powers: [false, []],
      stock: [false, []],
      powers_old: [false, []]
    });
  }

  getReport() {
    const options = {
      authorities: this.FormGroup.controls.authorities.value,
      powers: this.FormGroup.controls.powers.value,
      stock: this.FormGroup.controls.stock.value,
      powers_old: this.FormGroup.controls.powers_old.value
    };

    // If the modal was opened from an individual row, just return the options so the parent can download.
    if (this.data?.payload) {
      this.dialogRef.close(options);
      return;
    }

    this.individualsService.getCompanyExcel(options).subscribe(() => {
      this.dialogRef.close();
    });
  }

  close() {
    this.dialogRef.close();
  }
}
